export default __webpack_public_path__ + "assets/migraine_color_icon.png";